<template>
  <div>
    <v-form v-model="isFormValid">
      <AdminFieldBase
        v-for="header in headers"
        :Model="Model"
        :id="entity.id"
        :header="header"
        :type="header.type || FieldTypes.TEXT"
        :key="`${entity.id}-${header.value}`"
        @update="$emit('update', $event)"
      />
    </v-form>
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import FieldTypes from '@/constants/FieldTypes'

import AdminFieldBase from '@/components/AdminFieldBase'

import _get from 'lodash/get'

export default {
  name: 'AdminEditRecordForm',
  components: {
    AdminFieldBase,
  },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    entity: {
      type: Object,
      require: true,
      default: () => {},
    },
    headers: {
      type: Array,
      require: true,
      default: () => [],
    },
    fieldAttrs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isFormValid: false,
      FieldTypes,
    }
  },
  methods: {
    _get,
  },
  computed: {
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults, ...this.fieldAttrs }
    },
  },
  watch: {
    isFormValid(validity) {
      this.$emit('form:valid', validity)
    },
  },
}
</script>
